import { Flex, Heading, Button, Box, Text } from "@radix-ui/themes";
import { useState } from "react";
import Countdown from "react-countdown";
import { useTranslation } from "react-i18next";
import { ERROR_MODAL_AUTO_CLOSE_TIMEOUT } from "../../../shared/consts";

type CheckoutFailedProps = {
  errorMessage: string | undefined;
  onRetry: () => void;
  onClose: () => void;
};

export function CheckoutFailed({
  errorMessage,
  onRetry,
  onClose,
}: CheckoutFailedProps) {
  const [closeDate] = useState(
    () => Date.now() + ERROR_MODAL_AUTO_CLOSE_TIMEOUT,
  );
  const { t } = useTranslation();

  return (
    <Box className="w-full h-full p-4">
      <Flex
        justify="center"
        align="center"
        direction="column"
        className="w-full h-full"
      >
        <Flex
          justify="center"
          align="center"
          direction="column"
          className="flex-grow w-full"
        >
          <figure className="flex justify-center">
            <img
              src="/error.png"
              className="size-[150px] pointer-events-none select-none"
            />
          </figure>
          <Heading
            size="6"
            className="!text-3xl"
            mb="2"
            weight="bold"
            color="gray"
            highContrast
          >
            {t("paymentFailed")}
          </Heading>
          <Flex direction="column" gap="3" mb="6">
            <Text as="p" size="5" align="center" color="gray">
              {errorMessage}
            </Text>
          </Flex>
        </Flex>

        <Flex className="w-full" gap="4">
          <Button
            size="4"
            className="!basis-[calc(50%-0.5rem)] !min-h-14 !rounded-2xl"
            variant="solid"
            highContrast
            radius="large"
            color="gray"
            onClick={onRetry}
          >
            {t("tryAgain")}
          </Button>
          <Button
            size="4"
            className="!basis-[calc(50%-0.5rem)] !min-h-14 !rounded-2xl"
            variant="outline"
            highContrast
            radius="large"
            color="gray"
            onClick={onClose}
          >
            {t("close")}{" "}
            <Countdown
              date={closeDate}
              onComplete={onClose}
              renderer={({ seconds }) => <>({seconds} s)</>}
            ></Countdown>
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
}
